import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../services/notification.service';
import { MatDialog } from '@angular/material/dialog';
import { NotifyDialogComponent } from '../../notify-dialog/notify-dialog.component';

@Component({
  selector: 'app-banner3',
  templateUrl: './banner3.component.html',
  styleUrls: ['./banner3.component.scss']
})
export class Banner3Component implements OnInit {
  dialCode: any;
  submitted: boolean = false;

  notifyForm = this.fb.group({
    email:[null,[Validators.email, Validators.required]],
    phone:[null, [Validators.required]],
    zip:[null, [Validators.required]]
  });

  constructor(
    private fb: FormBuilder,
    private notificationService: NotificationService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {}

  CountryChangedEvent(e: any) {
    this.dialCode = e.dialCode;
    console.log(this.dialCode);
  }

  onNotify() {
    this.notifyForm.markAllAsTouched();
    let notify = this.notifyForm.value;
    this.submitted = true;

    if((notify.email || notify.phone) && this.notifyForm.valid) {
      if(notify.phone) {
        var phoneComponents = {
          number: notify.phone.substring(this.dialCode.length + 1, notify.phone.length)
        };
      }
      const loginData = {
        email: notify.email ? notify.email: '',
        countryCode: this.dialCode ? this.dialCode : '1',
        phoneNumber: phoneComponents ? phoneComponents.number:'',
        zipCode: notify.zip ? notify.zip : ''
      };
      this.notificationService.notify(loginData)
        .subscribe(
          (data: any) => {
            if (data.status == 'success') {
              this.onDialog();
            }
          },
          (error) => {}
        );
    }
  }

  onDialog() {
    const dialogRef = this.dialog.open(NotifyDialogComponent, {
      width: 'auto',
      height:'100%',
      data: {},
      panelClass: 'custom-dialog-container' 
    });

    dialogRef.afterClosed().subscribe(result => {
      this.notifyForm.controls['email'].setValue(null);
      this.notifyForm.controls['phone'].setValue(null);
      this.notifyForm.controls['zip'].setValue(null);
      this.notifyForm.reset();
    });
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
